// Custom events for DrawerTaskPanel

import { F_CLOUD_TASK_TYPE } from '@/utils/const';

// Event names
export const TASK_PANEL_EVENTS = {
  TASK_SUBMITTED: 'TASK_PANEL_TASK_SUBMITTED',
  EXPAND_PANEL: 'TASK_PANEL_EXPAND',
} as const;

// Event detail types
export interface TaskSubmittedEventDetail {
  timestamp: number;
}

export interface ExpandPanelEventDetail {
  timestamp: number;
}

/**
 * Dispatch event to refresh task panel when a new task is submitted
 * Uses the current route's task types from getFeatureTypes(router.pathname)
 */
export const dispatchTaskSubmitted = () => {
  const event = new CustomEvent<TaskSubmittedEventDetail>(
    TASK_PANEL_EVENTS.TASK_SUBMITTED,
    {
      detail: {
        timestamp: Date.now(),
      },
    },
  );
  window.dispatchEvent(event);
};

/**
 * Dispatch event to expand the task panel
 * This is used internally when the panel needs to be expanded
 */
export const dispatchExpandPanel = () => {
  const event = new CustomEvent<ExpandPanelEventDetail>(TASK_PANEL_EVENTS.EXPAND_PANEL, {
    detail: {
      timestamp: Date.now(),
    },
  });
  window.dispatchEvent(event);
};
